import './textInput.scoped.scss'
import { ChangeEvent, FocusEvent, ClipboardEvent, HTMLAttributes } from "react"

export interface TextInputProps {
  name: string
  value: string | number
  isInvalid: boolean
  errors?: string
  onChange: (event: ChangeEvent) => void
  onBlur: (event: FocusEvent) => void
  onPaste?: (event: ClipboardEvent) => void
  type?: "text" | "email" | "password"
  autoComplete?: string
  autoFocus?: boolean
  inputMode?: HTMLAttributes<HTMLInputElement>["inputMode"]
}

export const TextInput = (props: TextInputProps) => {
  return (
    <>
      <input
        name={props.name}
        type={props.type ?? "text"}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        className={`input ${props.isInvalid ? 'invalid' : ''}`}
        aria-invalid={props.isInvalid}
        onPaste={props.onPaste}
        autoComplete={props.autoComplete}
        autoFocus={props.autoFocus}
        inputMode={props.inputMode}
      />
      {props.isInvalid && (
        <div className={'validation-error column gap1 mt1'}>
          {props.errors}
        </div>
      )}
    </>
  )
}

